import serviceAxios from "../index";

//成套添加设备
export function addEquipment(data) {
	return serviceAxios({
		url: '/api/equipment/add',
		method: 'post',
		data
	})
}

// 成套设备列表
export function equipmentList(params) {
	return serviceAxios({
		url: '/api/equipment/list',
		method: 'get',
		params
	})
}

// 成套设备详情
export function equipmentDetail(params) {
	return serviceAxios({
		url: '/api/equipment/detail',
		method: 'get',
		params
	})
}

// 厂商详情
export function equipmentBusinessList(params) {
	return serviceAxios({
		url: '/api/master/masterList',
		method: 'get',
		params
	})
}

// 成套设备删除
export function equipmentDelete(params) {
	return serviceAxios({
		url: '/api/equipment/delEquipment',
		method: 'get',
		params
	})
}

//省市区
export function ProvinceList() {
	return serviceAxios({
		url: '/api/user/treeselect',
		method: 'get'
	})
}

//设备类型
export function equipmentType(params) {
	return serviceAxios({
		url: '/api/equipment/typeList',
		method: 'get',
		params
	})
}

//设备容量
export function equipmentVolumeApi(params) {
	return serviceAxios({
		url: '/api/equipment/volumeList',
		method: 'get',
		params
	})
}

//设备电压
export function equipmentVoltageApi(params) {
	return serviceAxios({
		url: '/api/equipment/voltageList',
		method: 'get',
		params
	})
}

// 订单列表
export function equOrderList(params) {
	return serviceAxios({
		url: '/api/order/oerderZList',
		method: 'get',
		params
	})
}

// 订单列表
export function equOrderListS(params) {
	return serviceAxios({
		url: '/api/order/oerderZListS',
		method: 'get',
		params
	})
}

export function equOrderListS070(params) {
	return serviceAxios({
		url: '/api/order/oerderZListS070',
		method: 'get',
		params
	})
}

// 订单列表
export function equOrderListSs(params) {
	return serviceAxios({
		url: '/api/order/oerderZListSs',
		method: 'get',
		params
	})
}

// export function equOrderListSs(params) {
// 	return serviceAxios({
// 		url: '/api/order/oerderZListSs',
// 		method: 'get',
// 		params
// 	})
// }


// 订单详情
export function equOrderDetail(params) {
	return serviceAxios({
		url: '/api/order/getDetail',
		method: 'get',
		params
	})
}

//成套修改订单
export function updateOrder(data) {
	return serviceAxios({
		url: '/api/order/update',
		method: 'post',
		data
	})
}

//成套修改订单
export function updateOrderEq(data) {
	return serviceAxios({
		url: '/api/order/updateEq',
		method: 'post',
		data
	})
}

//多设备成套修改订单
export function updateOrderDEq(data) {
	return serviceAxios({
		url: '/api/order/updateDEq',
		method: 'post',
		data
	})
}

//成套删除订单
export function delOrder(params) {
	return serviceAxios({
		url: '/api/order/delOrder',
		method: 'get',
		params
	})
}

// 获取个人信息
export function factory_userinfo(params) {
	return serviceAxios({
		url: '/api/master/getInfo',
		method: 'get',
		params
	})
}

// 更新个人信息
export function factory_info_update(data) {
	return serviceAxios({
		url: '/api/master/update',
		method: 'post',
		data
	})
}

// 修改密码
export function factory_info_password(params) {
	return serviceAxios({
		url: '/api/master/updatePwd',
		method: 'get',
		params
	})
}

// 首页统计
export function factory_index_data() {
	return serviceAxios({
		url: '/api/order/manufacturerStatistics',
		method: 'get'
	})
}

export function getButtonSizeApi(params) {
	return serviceAxios({
		url: '/api/order/statisticsButton',
		method: 'get',
		params
	})
}
// 环形图
export function factory_circle_chart() {
	return serviceAxios({
		url: '/api/order/manufacturerStatisticsChain',
		method: 'get'
	})
}

// 折线图
export function factory_line_chart() {
	return serviceAxios({
		url: '/api/order/manufacturerStatisticsWeek',
		method: 'get'
	})
}

//显示资金账号
export function payConfgApi(params) {
	return serviceAxios({
		url: '/api/payConfig',
		method: 'get',
		params
	})
}

//修改资金账号
export function updatePayConfgApi(data) {
	return serviceAxios({
		url: '/api/payConfig',
		method: 'post',
		data
	})
}

//首页上部统计
export function staTopApi(params) {
	return serviceAxios({
		url: '/api/order/manufacturerStatistics',
		method: 'get',
		params
	})

}

export function staTopApi2(params) {
	return serviceAxios({
		url: '/api/order/manufacturerStatistics2',
		method: 'get',
		params
	})

}

//统计1
export function sta1Api(params) {
	return serviceAxios({
		url: '/api/order/manufacturerOrderPower',
		method: 'get',
		params
	})

}

export function staApiAll(params) {
	return serviceAxios({
		url: '/api/order/manufacturerStatistics2',
		method: 'get',
		params
	})

}




//统计2
export function sta2Api(params) {
	return serviceAxios({
		url: '/api/order/manufacturerOrderComplete',
		method: 'get',
		params
	})

}

//统计3
export function sta3Api(params) {
	return serviceAxios({
		url: '/api/order/manufacturerOrderPowerIncome',
		method: 'get',
		params
	})

}

//统计4
export function sta4Api(params) {
	return serviceAxios({
		url: '/api/order/manufacturerOrderCompleteIncome',
		method: 'get',
		params
	})

}

//上传多个图片凭证
export function addVoucherAllApi(data) {
	return serviceAxios({
		url: '/api/order/addVoucherAll',
		method: 'post',
		data
	})
}

//评价列表
export function pingjiaListApi(params) {
	return serviceAxios({
		url: '/api/order/oerderCommentList',
		method: 'get',
		params
	})
}
